import { render, staticRenderFns } from "./spellTracker.vue?vue&type=template&id=3a92ef0a&scoped=true&"
import script from "./spellTracker.vue?vue&type=script&lang=js&"
export * from "./spellTracker.vue?vue&type=script&lang=js&"
import style0 from "./spellTracker.vue?vue&type=style&index=0&id=3a92ef0a&scoped=true&lang=css&"
import style1 from "./spellTracker.vue?vue&type=style&index=1&id=3a92ef0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a92ef0a",
  null
  
)

export default component.exports